// extracted by mini-css-extract-plugin
export default {"main":"MesRecienteSelector_main__0lM--"};